import React from 'react';

const AffiliateProgram: React.FC = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <h1>AICEO Affiliate Program</h1>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>Partner With Us</h2>
        <p>
          Join the AICEO Affiliate Program and earn commissions by referring entertainment business 
          owners to our platform. Whether you're a business consultant, industry influencer, or 
          content creator in the entertainment business space, our affiliate program offers you 
          the opportunity to monetize your network while providing real value to your audience.
        </p>
      </section>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>Program Benefits</h2>
        <ul>
          <li><strong>Generous Commission Structure:</strong> Earn 20% commission on all referred subscriptions for the first year.</li>
          <li><strong>Recurring Revenue:</strong> Receive commissions for as long as your referrals remain active subscribers.</li>
          <li><strong>Extended Cookie Duration:</strong> 90-day cookie tracking ensures you get credit for delayed conversions.</li>
          <li><strong>Professional Marketing Materials:</strong> Access to banners, email templates, and other promotional assets.</li>
          <li><strong>Dedicated Affiliate Dashboard:</strong> Track your referrals, clicks, and earnings in real-time.</li>
          <li><strong>Timely Payments:</strong> Monthly payouts via PayPal, Stripe, or direct deposit.</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>Who Should Join?</h2>
        <ul>
          <li><strong>Business Consultants:</strong> Offer your clients a powerful tool for location analysis and business planning.</li>
          <li><strong>Industry Bloggers:</strong> Monetize your content while providing valuable resources to your readers.</li>
          <li><strong>Franchise Brokers:</strong> Help your clients make data-driven decisions about potential locations.</li>
          <li><strong>Real Estate Professionals:</strong> Add value for clients looking to open entertainment businesses.</li>
          <li><strong>Industry Associations:</strong> Provide member benefits while generating additional revenue.</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>How It Works</h2>
        <ol>
          <li><strong>Apply:</strong> Fill out our affiliate application form below.</li>
          <li><strong>Get Approved:</strong> Our team will review your application and respond within 48 hours.</li>
          <li><strong>Promote:</strong> Share your unique affiliate link through your website, social media, or email.</li>
          <li><strong>Earn:</strong> Receive commissions when people sign up through your link.</li>
          <li><strong>Get Paid:</strong> Receive monthly payments for all qualified conversions.</li>
        </ol>
      </section>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>Commission Structure</h2>
        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
          <thead>
            <tr style={{ backgroundColor: '#f2f2f2' }}>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Subscription Type</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Commission Rate</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Monthly Plans</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>20%</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>12 months</td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Annual Plans</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>25%</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>First year</td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Enterprise Plans</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Custom</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Negotiable</td>
            </tr>
          </tbody>
        </table>
      </section>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>Apply Now</h2>
        <p>
          Ready to join our affiliate program? Fill out the application form below or contact our 
          affiliate team at <a href="mailto:affiliates@aiceo.com" style={{ color: '#7FE7D9', textDecoration: 'none' }}>affiliates@aiceo.com</a> for more information.
        </p>
        <div style={{ marginTop: '1rem' }}>
          <button 
            style={{ 
              backgroundColor: '#7FE7D9', 
              color: '#1e1e1e', 
              border: 'none', 
              padding: '10px 20px', 
              borderRadius: '4px', 
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Apply to Become an Affiliate
          </button>
        </div>
      </section>
      
      <section>
        <h2>Frequently Asked Questions</h2>
        <div>
          <h3>How soon will I get paid?</h3>
          <p>Payments are processed on the 15th of each month for the previous month's earnings.</p>
          
          <h3>Is there a minimum payout threshold?</h3>
          <p>Yes, the minimum payout threshold is $50.</p>
          
          <h3>Can I promote AICEO on multiple websites?</h3>
          <p>Yes, you can promote AICEO on all websites that you own, as long as they comply with our affiliate terms.</p>
          
          <h3>Do you provide marketing materials?</h3>
          <p>Yes, we provide a variety of banners, email templates, and other promotional materials in your affiliate dashboard.</p>
        </div>
      </section>
    </div>
  );
};

export default AffiliateProgram;
